import React from 'react';
import { ArrowRight } from 'lucide-react';

const QuickActionsCard = ({ actions = [] }) => (
  <div className="ab-card ab-surface-light">
    <div className="ab-card-header">
      <h3 className="ab-card-title">Quick Actions</h3>
    </div>
    <div className="ab-quick-actions">
      {actions.map((action) => {
        const Icon = action.icon;
        return (
          <button
            key={action.id}
            type="button"
            className="ab-quick-action"
            onClick={action.onClick}
            title={action.description}
          >
            <div className={`ab-quick-action-icon ${action.accent || 'primary'}`}>
              <Icon size={20} />
            </div>
            <div className="ab-quick-action-text">
              <span className="ab-quick-action-title">{action.title}</span>
              <span className="ab-quick-action-desc">{action.description}</span>
            </div>
            <ArrowRight size={16} className="ab-quick-action-arrow" />
          </button>
        );
      })}
    </div>
  </div>
);

export default QuickActionsCard;
